<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Fichiers du dossier</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <mat-selection-list #selectefFolderFilesList>
                @for (file of folderFiles; track file.id) {
                    <mat-list-option [value]="file.id">
                        <div class="file-line-container">
                            <div class="filename">{{ file?.name | slice: 0 : 50 }}{{ file?.name.length > 50 ? '...' : '' }}</div>
                            <div class="file-size">
                                {{ file?.size | avmFileSize }}
                            </div>
                        </div>
                    </mat-list-option>
                }
            </mat-selection-list>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" [disabled]="false" (click)="valid(selectefFolderFilesList)">Valider</button>
    </mat-card-actions>
</mat-card>
